import { h } from '@stencil/core';
import { ECarouselRelation } from '@pes-ui/utils';
export class LifecycleServicesWrapper {
  constructor() {
    this.sectionTitle = undefined;
    this.data = undefined;
    this.versionLabel = undefined;
    this.relationType = undefined;
    this.isBackgroundGrey = false;
    this.showMoreLabel = undefined;
    this.showLessLabel = undefined;
    this.selectLabel = undefined;
    this.sortByLabel = undefined;
    this.defaultRecordCount = 2;
    this.isAPCSite = false;
    this.apcCta = undefined;
    this.productAvailabilityInfo = undefined;
    this.commerceConnectorSettings = null;
    this.apcCtaUrl = undefined;
    this.host = '';
    this.agentChatCscId = undefined;
    this.countryCode = undefined;
    this.languageCode = undefined;
    this.useNewUiForLifecycle = false;
  }
  render() {
    var _a, _b;
    if (this.useNewUiForLifecycle) {
      return (h("pes-products-filter", { sectionTitle: this.sectionTitle, data: this.data, showMoreLabel: this.showMoreLabel, showLessLabel: this.showLessLabel, selectLabel: this.selectLabel, sortByLabel: this.sortByLabel, defaultRecordCount: this.defaultRecordCount, isAPCSite: this.isAPCSite, apcCta: this.apcCta, productAvailabilityInfo: this.productAvailabilityInfo, commerceConnectorSettings: this.commerceConnectorSettings, apcCtaUrl: this.apcCtaUrl, host: this.host, agentChatCscId: this.agentChatCscId, relationType: (_a = this.relationType) !== null && _a !== void 0 ? _a : ECarouselRelation.crossSellLife, countryCode: this.countryCode, languageCode: this.languageCode }));
    }
    return (h("pes-products-carousel", { sectionTitle: this.sectionTitle, data: this.data, versionLabel: this.versionLabel, relationType: (_b = this.relationType) !== null && _b !== void 0 ? _b : ECarouselRelation.crossSellLife, isBackgroundGrey: this.isBackgroundGrey }));
  }
  static get is() { return "pes-lifecycle-services-wrapper"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["pes-lifecycle-services-wrapper.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["pes-lifecycle-services-wrapper.css"]
    };
  }
  static get properties() {
    return {
      "sectionTitle": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Title of the section"
        },
        "attribute": "section-title",
        "reflect": false
      },
      "data": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "(IProductCardIdRegular | IProductCardIdSoftware)[]",
          "resolved": "(IProductCardIdRegular | IProductCardIdSoftware)[]",
          "references": {
            "IProductCardIdRegular": {
              "location": "import",
              "path": "../products-carousel/types"
            },
            "IProductCardIdSoftware": {
              "location": "import",
              "path": "../products-carousel/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "List of product card objects"
        }
      },
      "versionLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "version-label",
        "reflect": false
      },
      "relationType": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Type of carousel"
        },
        "attribute": "relation-type",
        "reflect": false
      },
      "isBackgroundGrey": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-background-grey",
        "reflect": false,
        "defaultValue": "false"
      },
      "showMoreLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "show-more-label",
        "reflect": false
      },
      "showLessLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "show-less-label",
        "reflect": false
      },
      "selectLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "select-label",
        "reflect": false
      },
      "sortByLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "sort-by-label",
        "reflect": false
      },
      "defaultRecordCount": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "default-record-count",
        "reflect": false,
        "defaultValue": "2"
      },
      "isAPCSite": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-a-p-c-site",
        "reflect": false,
        "defaultValue": "false"
      },
      "apcCta": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TApcCta",
          "resolved": "{ urls: { apcHost: string; }; labels: { addToCartButtonLabel: string; vatLabel: string; inStockLabel: string; authToAddToFavorites: string; removeFromFavorites: string; addToFavorites: string; favorites: string; itemAddedTo: string; signIn: string; createAccount: string; itemRemovedFrom: string; failedResponse: string; }; }",
          "references": {
            "TApcCta": {
              "location": "import",
              "path": "../../globals/apc-cta/types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "productAvailabilityInfo": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TProductAvailabilityInfo",
          "resolved": "{ howToBuyShowing: { [productId: string]: boolean; }; addToFavoritesInfo: TAddToFavoritesInfo; prices: TPrices; substitution: TSubstitution; factoryStore: TFactoryStore; availability: TAvailability; }",
          "references": {
            "TProductAvailabilityInfo": {
              "location": "import",
              "path": "../../globals/apc-cta/types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "commerceConnectorSettings": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "CommerceConnectorSettings | null",
          "resolved": "{ options: CommerceConnectorOptions; labels: CommerceConnectorLabels; messages: CommerceConnectorMessages; }",
          "references": {
            "CommerceConnectorSettings": {
              "location": "import",
              "path": "../commerce-connector/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "defaultValue": "null"
      },
      "apcCtaUrl": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "apc-cta-url",
        "reflect": false
      },
      "host": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "host",
        "reflect": false,
        "defaultValue": "''"
      },
      "agentChatCscId": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "agent-chat-csc-id",
        "reflect": false
      },
      "countryCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "country-code",
        "reflect": false
      },
      "languageCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "language-code",
        "reflect": false
      },
      "useNewUiForLifecycle": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "use-new-ui-for-lifecycle",
        "reflect": false,
        "defaultValue": "false"
      }
    };
  }
}
